module.exports = __webpack_public_path__ + "static/media/12.98905a0b.jpg";